<app-work-form-container
    [existingWork]="existingWork"
    [form]="form"
    [workDataFieldsToCopy]="['description', 'note']"
    (submit)="submit()"
    (closeCallback)="close()"
>
    <div work-form-select>
        <div [ngClass]="{
            formWrapper: true,
            'formWrapper-splitted': useSplitter(),
        }">
            <app-work-detail-select-service
                (selectedService)="form.patchValue({ serviceId: $event })"
                [preselected]="form.value.serviceId || this.store.globalGlobalStore.loggedUserStore.selectedServiceId()"
                [workType]="WorkTypeEnum.SUGGESTION"
                [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
            ></app-work-detail-select-service>

            @if (form.value.serviceId) {
                <app-select-person [form]="form" [serviceId]="form.value.serviceId"></app-select-person>
                <app-date-input [form]="form" id="dateFrom" [prefix]="prefix"></app-date-input>

                <app-select-user
                    [form]="form"
                    id="userId"
                    [label]="prefix + 'fields.userId'"
                    [serviceId]="form.value.serviceId || null"
                ></app-select-user>

                <app-number-input
                    id="sequenceNumber"
                    [form]="form"
                    [prefix]="prefix"
                ></app-number-input>

                @if (suggestionType() === WorkDataSuggestionTypeEnum.complaint) {
                    <app-select-input
                        [form]="form"
                        id="complaintTypeId"
                        [prefix]="prefix"
                        [infiniteScroll]="complaintTypesScroll()"
                        [valueKey]="'id'"
                    >
                        <ng-template #item let-item>
                            {{ item.name }} ({{ item.daysToProcess || 0 }})
                        </ng-template>
                        <ng-template #selectedItem let-item>
                            {{ item.name }} ({{ item.daysToProcess || 0 }})
                        </ng-template>
                    </app-select-input>
                }

                @if (suggestionType() === WorkDataSuggestionTypeEnum.finding) {
                    <app-select-input
                        [form]="form"
                        id="priority"
                        [prefix]="prefix"
                        [staticOptions]="priorityEnumOptions"
                        [valueKey]="'value'"
                    ></app-select-input>
                }

                <app-input-wysiwyg
                    class="itemFull"
                    [placeholder]="prefix + 'fields.description'"
                    [form]="form"
                    id="description"
                    editorKey="WorkSuggestionDescription"
                    [height]="350"
                    [ngClass]="{
                        'fr-3': !useSplitter(),
                        'fr-full': useSplitter(),
                    }"
                ></app-input-wysiwyg>

                <app-card
                    class="fh-3 itemFull evaluationContainer"
                    [ngClass]="{
                        'fr-3': !useSplitter(),
                        'fr-full': useSplitter(),
                    }"
                    [title]="prefix + 'fields.evaluation'"
                >
                    <ng-template #content>
                        <div class="grid-4col input-grid-gaps">
                            <div class="fr-3 input-grid-gaps align-items-center"
                                [ngClass]="{
                                    'grid-2col': !useSplitter(),
                                    'grid-1col': useSplitter(),
                                }"
                            >
                                <app-date-input [form]="form" id="evaluationDate" [showTime]="true"
                                    [prefix]="prefix"></app-date-input>

                                <app-select-user
                                    [form]="form"
                                    id="evaluatorId"
                                    [label]="prefix + 'fields.evaluatorId'"
                                    [serviceId]="form.value.serviceId || null"
                                ></app-select-user>

                                <app-social-service-select-offer
                                    [label]="prefix + 'fields.offerId'"
                                    [serviceId]="serviceId()"
                                    [date]="dateFrom()"
                                    [allowedTypes]="[SocialServiceOperationEnum.BILL, SocialServiceOperationEnum.INFORMATIVE]"
                                    [singleSelectedMode]="true"
                                    [showOperations]="false"
                                    [showApplications]="true"
                                    [preselectedOffers]="preselectedOffers()"
                                    [additionalFilter]="[[{ column: 'payment', value: ['0'], operator: 'EQ' }]]"
                                    (selectedOffers)="onOfferSelected($event)"
                                ></app-social-service-select-offer>

                                <app-check-input
                                    id="clientPresence"
                                    [form]="form"
                                    [prefix]="prefix"
                                ></app-check-input>

                                <app-select-input
                                    [form]="form"
                                    id="state"
                                    [prefix]="prefix"
                                    [staticOptions]="workDataSuggestionEvaluationStateEnumOptions"
                                    [valueKey]="'value'"
                                ></app-select-input>

                                <app-switch-input
                                    id="onlyForWorker"
                                    [form]="form"
                                    [prefix]="prefix"
                                ></app-switch-input>

                                <app-service-pattern-wysiwyg
                                    class="itemFull"
                                    [ngClass]="{
                                        'fr-full': !useSplitter(),
                                        'fr-1': useSplitter(),
                                    }"
                                    [placeholder]="prefix + 'fields.evaluation'"
                                    [form]="form"
                                    id="evaluation"
                                    editorKey="WorkSuggestionEvaluation"
                                    [height]="350"
                                    [personId]="personId() || 0"
                                    [serviceId]="serviceId() || 0"
                                    [usage]="patternUsage()"
                                    (addedPattern)="formSetText(form,'evaluation', $event.content)"
                                ></app-service-pattern-wysiwyg>
                            </div>

                            <p-listbox
                                [options]="store.evaluationRecords()"
                                [(ngModel)]="selectEvaluation"
                                (onChange)="evaluationListChange($event)"
                                [filter]="true"
                                [filterPlaceHolder]="'database.persons.history' | translate"
                                emptyMessage="{{'database.persons.noResultsFound' | translate}}"
                                optionLabel="key"
                                dataKey="index"
                                class="h-full"
                                scrollHeight="calc(100vh - 20rem)"
                            >
                                <ng-template let-evaluation pTemplate="item">
                                    <div (contextmenu)="rightClick(contextMenu, $event, evaluation)"
                                        class="flex-column gap-x-small w-full">
                                        <div class="flex justify-content-between">
                                            <span>{{ evaluation.evaluationDateFormatted }}</span>
                                            @if (evaluation.onlyForWorker) {
                                                <app-icon class="mr-2" icon="pi-eye-slash"></app-icon>
                                            }
                                        </div>
                                        @if (evaluation?.savedBy) {
                                            <app-user-chip [user]="evaluation?.savedBy"></app-user-chip>
                                        }
                                    </div>
                                </ng-template>
                            </p-listbox>
                        </div>
                    </ng-template>
                </app-card>

                <app-input-wysiwyg
                    class="itemFull"
                    [ngClass]="{
                        'fr-3': !useSplitter(),
                        'fr-full': useSplitter(),
                    }"
                    [placeholder]="prefix + 'fields.note'"
                    [form]="form"
                    id="note"
                    editorKey="WorkSuggestionNote"
                    [height]="250"
                ></app-input-wysiwyg>

                <app-file-upload-box
                    class="itemFull"
                    [ngClass]="{
                        'fr-3': !useSplitter(),
                        'fr-full': useSplitter(),
                    }"
                    [multiple]="true"
                    [existingFiles]="$any(form.value.files) || []"
                ></app-file-upload-box>
            }
        </div>
    </div>
</app-work-form-container>

<p-contextMenu
    #contextMenu
    [model]="contextMenuItems"
    appendTo="body"
    styleClass="evaluations-context-menu"
></p-contextMenu>
